import classNames from '@/common/utils/classNames';

/**
 * The Toman currency sign — used instead of the word «تومان» wherever a price is rendered.
 * Sized to the surrounding text and painted with `currentColor`; screen readers still hear «تومان».
 * The glyph lives once in globals.css (`.toman-sign` mask), so each price adds only an empty span.
 */
export const Toman = ({ className }: { className?: string }) => (
  <span role="img" aria-label="تومان" className={classNames('toman-sign', className)} />
);

/** `<price> <Toman />` on one line (the number never wraps away from its sign). */
export const TomanPrice = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <span className={classNames('inline-flex items-center gap-1 whitespace-nowrap', className)}>
    {children}
    <Toman />
  </span>
);

/**
 * Renders a «… <amount> تومان» string (Plasmic state, or text that arrives ready-made from the API)
 * with the sign; any other value passes through untouched.
 */
export const tomanSign = (value: React.ReactNode): React.ReactNode => {
  if (typeof value !== 'string') return value;
  const match = value.match(/^([\s\S]*?)([\d۰-۹][\d۰-۹,٬.]*)\s*تومان\s*$/);
  if (!match) return value;
  return (
    <>
      {match[1]}
      <TomanPrice>{match[2]}</TomanPrice>
    </>
  );
};

export default Toman;
